export const baseUrl = 'https://services.kestatesclients.com'; //some changes by faroq in listing not showing on github
export const profileImageBaseUrl = 'https://services.kestatesclients.com/public/profile_images';
export const propertyImagesUrl = 'https://services.kestatesclients.com/public/property_images';
export const ownerDocumentsUrl = 'https://services.kestatesclients.com/public/uploads';
export const propertyDocumentsUrl = 'https://services.kestatesclients.com/public/property_docs';
